(function () {
  const STORAGE_KEY_PREFIX = 'pokespott-displays-scroll-hint';

  function storageKey(carousel) {
    const id = carousel.dataset.pokespottScrollHintId || 'default';
    return `${STORAGE_KEY_PREFIX}-${id}`;
  }
  const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function wait(ms) {
    return new Promise((resolve) => window.setTimeout(resolve, ms));
  }

  function isScrollable(scroller) {
    return scroller.scrollWidth - scroller.clientWidth > 24;
  }

  function nudgeScroller(scroller, distance) {
    const start = scroller.scrollLeft;
    scroller.scrollTo({ left: start + distance, behavior: 'smooth' });
    return wait(650).then(() => {
      scroller.scrollTo({ left: start, behavior: 'smooth' });
    });
  }

  async function runHint(carousel) {
    if (sessionStorage.getItem(storageKey(carousel)) === '1') return;

    const scroller = carousel.querySelector('slideshow-slides[ref="scroller"]');
    if (!scroller || !isScrollable(scroller)) return;

    let cancelled = false;
    const cancel = () => {
      cancelled = true;
      carousel.classList.remove('is-hinting');
      carousel.classList.add('is-hint-hidden');
      sessionStorage.setItem(storageKey(carousel), '1');
    };

    const onInteract = () => cancel();
    scroller.addEventListener('scroll', onInteract, { once: true, passive: true });
    scroller.addEventListener('pointerdown', onInteract, { once: true });
    carousel.querySelector('.slideshow-control--next')?.addEventListener('click', onInteract, { once: true });

    await wait(900);
    if (cancelled) return;

    const slide = carousel.querySelector('.resource-list__slide');
    const gap = Number.parseFloat(getComputedStyle(scroller).gap) || 28;
    const slideWidth = slide?.getBoundingClientRect().width || 260;
    const distance = Math.min(slideWidth * 0.45 + gap, scroller.scrollWidth - scroller.clientWidth);

    carousel.classList.add('is-hinting');
    await nudgeScroller(scroller, distance);
    await wait(500);

    if (!cancelled) {
      carousel.classList.remove('is-hinting');
      carousel.classList.add('is-hint-hidden');
      sessionStorage.setItem(storageKey(carousel), '1');
    }
  }

  function updateScrollFade(carousel, scroller) {
    if (!isScrollable(scroller)) {
      carousel.classList.add('is-at-end');
      return;
    }

    const atEnd = scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth - 16;
    carousel.classList.toggle('is-at-end', atEnd);
  }

  function markStaticIfNeeded(carousel, scroller) {
    if (!isScrollable(scroller)) {
      carousel.classList.add('is-static', 'is-at-end');
      carousel.classList.remove('is-hinting');
      return true;
    }

    carousel.classList.remove('is-static');
    return false;
  }

  function initCarousel(carousel) {
    const scroller = carousel.querySelector('slideshow-slides[ref="scroller"]');
    if (!scroller) return;

    const onScroll = () => {
      if (scroller.scrollLeft > 8) {
        carousel.classList.remove('is-hinting');
      }
      updateScrollFade(carousel, scroller);
    };

    const onResize = () => {
      markStaticIfNeeded(carousel, scroller);
      updateScrollFade(carousel, scroller);
    };

    scroller.addEventListener('scroll', onScroll, { passive: true });
    onResize();
    window.addEventListener('resize', onResize, { passive: true });

    if (markStaticIfNeeded(carousel, scroller)) return;

    if (REDUCED_MOTION) {
      if (isScrollable(scroller)) carousel.classList.add('is-hintable');
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          observer.disconnect();
          runHint(carousel);
        }
      },
      { threshold: 0.45 }
    );

    observer.observe(carousel);
  }

  function init() {
    document.querySelectorAll('[data-pokespott-scroll-hint]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
